import { render, staticRenderFns } from "./PluginTable.vue?vue&type=template&id=42f62e09&scoped=true"
import script from "./PluginTable.vue?vue&type=script&lang=js"
export * from "./PluginTable.vue?vue&type=script&lang=js"
import style0 from "./PluginTable.vue?vue&type=style&index=0&id=42f62e09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f62e09",
  null
  
)

export default component.exports